import { NavLink, Link, useLocation } from "react-router-dom";
import { Home, Search, Sprout, MessagesSquare, User as UserIcon, Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/", icon: Home, label: "Ana Sayfa", id: "home", exact: true },
  { to: "/ilanlar", icon: Search, label: "İlanlar", id: "listings" },
  { to: "/ciftligim", icon: Sprout, label: "Çiftliğim", id: "farm", auth: true },
  { to: "/forum", icon: MessagesSquare, label: "Forum", id: "forum" },
];

/** Mobilde uygulama benzeri alt sekme çubuğu + "İlan Ver" yüzen butonu. */
export const MobileTabBar = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const hidden = pathname.startsWith("/yonetim") || pathname.startsWith("/kasap");
  const fabHidden = hidden || pathname.startsWith("/ilan/") || pathname.startsWith("/ilan-ver");
  if (hidden) return null;

  const tabs = [
    ...TABS.map((t) => (t.auth && !user ? { ...t, to: "/giris" } : t)),
    user
      ? { to: "/panel/profil", icon: UserIcon, label: "Profil", id: "profile" }
      : { to: "/giris", icon: UserIcon, label: "Giriş", id: "profile" },
  ];

  return (
    <>
      {!fabHidden && (
      <Link
        to={user ? "/ilan-ver" : "/giris"}
        data-testid="mobile-fab-create-listing"
        aria-label="İlan Ver"
        style={{
          zIndex: "var(--z-bottom-nav)",
          bottom: "calc(var(--mobile-bottom-nav-height) + env(safe-area-inset-bottom) + 16px)",
        }}
        className="app-tap fixed right-4 flex h-14 w-14 items-center justify-center rounded-full bg-accent text-accent-foreground shadow-xl shadow-primary/25 md:hidden"
      >
        <Plus className="h-7 w-7" strokeWidth={2.6} />
      </Link>
      )}

      <nav
        data-testid="mobile-bottom-nav"
        style={{ zIndex: "var(--z-bottom-nav)", paddingBottom: "env(safe-area-inset-bottom)" }}
        className="fixed bottom-0 left-0 right-0 grid grid-cols-5 border-t border-border bg-background/95 backdrop-blur-md md:hidden"
      >
        {tabs.map((t) => (
          <NavLink
            key={t.id}
            to={t.to}
            end={t.exact}
            data-testid={`bottom-nav-${t.id}`}
            className={({ isActive }) =>
              `app-tap relative flex min-h-[56px] flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${
                isActive ? "text-primary" : "text-muted-foreground"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={`absolute top-0 h-0.5 w-8 rounded-full bg-accent transition-opacity ${
                    isActive ? "opacity-100" : "opacity-0"
                  }`}
                />
                <t.icon className="h-[22px] w-[22px]" strokeWidth={isActive ? 2.5 : 2} />
                {t.label}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </>
  );
};
